import React, { useMemo } from "react";
import CanvasJSReact from "@canvasjs/react-charts";
import { generateMixedChart } from "./reportUtils/utils";

const MixedReport = ({
  spo2Reports,
  pressureReports,
  temperatureReports,
  startDate,
  endDate,
}) => {
  var CanvasJSChart = CanvasJSReact.CanvasJSChart;

  const layout = useMemo(() => {
    // restrict data to the selected date range
    const filteredSpo2Reports = spo2Reports.filter(
      (report) =>
        new Date(report.data.Date) >= new Date(startDate) &&
        new Date(report.data.Date) <= new Date(endDate),
    );

    const filteredPressureReports = pressureReports.filter(
      (report) =>
        new Date(report.data.Date) >= new Date(startDate) &&
        new Date(report.data.Date) <= new Date(endDate),
    );

    const filteredTemperatureReports = temperatureReports.filter(
      (report) =>
        new Date(report.data.Date) >= new Date(startDate) &&
        new Date(report.data.Date) <= new Date(endDate),
    );

    return generateMixedChart(
      filteredPressureReports,
      filteredSpo2Reports,
      filteredTemperatureReports,
    );
  }, [
    startDate,
    endDate,
    spo2Reports,
    pressureReports,
    temperatureReports,
  ]);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {layout !== null && <CanvasJSChart options={layout} />}
    </div>
  );
};

export default MixedReport;
